/**
 * Source-status enum used on every section of a BlueprintResult so the UI (and
 * future analytics/audit) can always tell where a value came from.
 *
 *   MOCK_POC       — Placeholder illustrative data. Never to be treated as truth.
 *   VALIDATED_V299 — Output produced by the validated Life Blueprint V2.9.9
 *                    rules (the Excel Golden Master). Not implemented yet.
 *
 * Only these two values are permitted for this phase.
 */
export const SOURCE_STATUS = Object.freeze({
  MOCK_POC: "MOCK_POC",
  VALIDATED_V299: "VALIDATED_V299",
});

/**
 * Engine version identifiers.
 * The application always ships pointing to one of these.
 */
export const ENGINE_VERSION = Object.freeze({
  POC_MOCK: "POC-MOCK",
  V299: "V2.9.9",
});

/** Human-readable labels used purely for badge/tooltip display. */
export const ENGINE_VERSION_LABEL = Object.freeze({
  "POC-MOCK": "PoC 示例引擎 (Mock)",
  "V2.9.9": "Life Blueprint V2.9.9 (Golden Master)",
});
